import { connect } from 'react-redux';
import I18n from 'I18n';
import { appendFormFieldGroup as appendFormFieldGroupAction, updateDraggedItem as updateDraggedItemAction
// @ts-expect-error types missing
} from 'FormsUI/actions/FormDragDrop';
import { fetchAdConsentLabel as fetchAdConsentLabelAction } from 'FormsUI/actions/AdConsent';
// @ts-expect-error types missing
import PropertiesList from 'FormsUI/components/editor/leftPanel/properties/PropertiesList';
// @ts-expect-error types missing
import { getAllUsedFormFieldObjectTypeId } from 'FormsUI/selectors/FormDefinition';
import { HS_DATA_PRIVACY_ADS_CONSENT_FIELD } from 'FormsUI/constants/AdConsent';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const AdConsentProperties = ({
  updateDraggedItem,
  appendFormFieldGroup,
  fetchAdConsentLabel,
  usedFormFieldIds
}) => /*#__PURE__*/_jsx(View, {
  "data-test-id": "ad-consent-properties",
  paddingBlockStart: "400",
  as: "div",
  children: /*#__PURE__*/_jsx(PropertiesList, {
    usedFormFieldIds: usedFormFieldIds,
    properties: [Object.assign({}, HS_DATA_PRIVACY_ADS_CONSENT_FIELD, {
      label: I18n.text('editor.form.properties.adConsent')
    })],
    updateDraggedItem: propertyId => {
      updateDraggedItem(propertyId);
      fetchAdConsentLabel();
    },
    appendFormFieldGroup: propertyId => {
      appendFormFieldGroup(propertyId);
      fetchAdConsentLabel();
    }
  })
});
const mapStateToProps = state => ({
  usedFormFieldIds: getAllUsedFormFieldObjectTypeId(state)
});
const mapActionsToProps = {
  updateDraggedItem: updateDraggedItemAction,
  appendFormFieldGroup: appendFormFieldGroupAction,
  fetchAdConsentLabel: fetchAdConsentLabelAction
};
export default connect(mapStateToProps, mapActionsToProps)(AdConsentProperties);